module.exports = __webpack_public_path__ + "static/group_image-5e718ff8613ebef2b7cd702fe98d5e72.svg";